// component
import Iconify from "../../components/Iconify";

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: "dashboard",
    path: "/dashboard/admin",
    icon: getIcon("eva:pie-chart-2-fill")
  },
  // {
  //   title: "hosting",
  //   path: "/dashboard/hosting",
  //   icon: getIcon("ant-design:cloud-filled")
  // },
  {
    title: "lead center",
    path: "/dashboard/enquiries",
    icon: getIcon("eva:people-fill")
  },
  {
    title: "clients",
    path: "/dashboard/clients",
    icon: getIcon("eva:people-fill")
  },
  // {
  //   title: "integration",
  //   path: "/dashboard/coming-soon",
  //   icon: getIcon("eva:file-text-fill")
  // },
  {
    title: "marketing",
    path: "/dashboard/campaigns",
    icon: getIcon("material-symbols:campaign"),
    children: [
      { title: "Campaigns", path: "/dashboard/campaigns/campaigns" },
      {
        title: "Email templates",
        path: "/dashboard/campaigns/email-templates"
      },
      { title: "Reports", path: "/dashboard/campaigns/reports" }
    ]
  }
];

export default navConfig;
